import {
  FETCH_COMMUNITY_ABOUT,
  FETCH_COMMUNITY_ABOUT_SUCCESS,
  FETCH_COMMUNITY_ABOUT_FAILURE,
} from './actionTypes';

const initialState = {
  supportingMembers: [],
  contact: null,
  description: null,
  isLoading: false,
  support: null,
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMMUNITY_ABOUT:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_COMMUNITY_ABOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        description: action.description,
        supportingMembers: action.supportingMembers,
        support: action.support,
        contact: action.contact,
      };
    case FETCH_COMMUNITY_ABOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    }
  return state;
}
